import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicSettings = _resolveComponent("BasicSettings")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_SecurityProtection = _resolveComponent("SecurityProtection")!
  const _component_RealTimeProtection = _resolveComponent("RealTimeProtection")!
  const _component_RegularPhysicalExamination = _resolveComponent("RegularPhysicalExamination")!
  const _component_TimingAntivirus = _resolveComponent("TimingAntivirus")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_FlowControl = _resolveComponent("FlowControl")!
  const _component_OnlineBlackAndWhiteList = _resolveComponent("OnlineBlackAndWhiteList")!
  const _component_EarlyWarningAndMonitoring = _resolveComponent("EarlyWarningAndMonitoring")!
  const _component_LeakFix = _resolveComponent("LeakFix")!
  const _component_UsbManage = _resolveComponent("UsbManage")!
  const _component_BaselineScan = _resolveComponent("BaselineScan")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    type: "card",
    size: "small",
    class: _normalizeClass(["group-policy-content", { readonly: _ctx.operateType === _ctx.OperateType.read }]),
    modelValue: _ctx.systemTab,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.systemTab) = $event)),
    "before-leave": _ctx.switchTab
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('groupPolicySettings.tabWindows'),
        name: "1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            class: "content-adapt define-tabs",
            modelValue: _ctx.activeName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
            "before-leave": _ctx.switchTab
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('groupPolicySettings.paneBasic'),
                name: _ctx.SETTING_PANE_NAMES.basicSettings
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BasicSettings, {
                    "active-name": _ctx.activeName,
                    name: _ctx.SETTING_PANE_NAMES.basicSettings,
                    "policy-id": _ctx.policyId,
                    onCancel: _ctx.cancel,
                    onSave: _ctx.save,
                    "operate-type": _ctx.operateType
                  }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type"])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('groupPolicySettings.paneSecurity'),
                name: _ctx.SETTING_PANE_NAMES.securityProtection,
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SecurityProtection, {
                    "active-name": _ctx.activeName,
                    name: _ctx.SETTING_PANE_NAMES.securityProtection,
                    "policy-id": _ctx.policyId,
                    onCancel: _ctx.cancel,
                    onSave: _ctx.save,
                    "operate-type": _ctx.operateType
                  }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type"])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('groupPolicySettings.paneRealtime'),
                name: _ctx.SETTING_PANE_NAMES.realTimeProtection,
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_RealTimeProtection, {
                    "active-name": _ctx.activeName,
                    name: _ctx.SETTING_PANE_NAMES.realTimeProtection,
                    "policy-id": _ctx.policyId,
                    onCancel: _ctx.cancel,
                    onSave: _ctx.save,
                    "operate-type": _ctx.operateType
                  }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type"])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('groupPolicySettings.paneScheduledExam'),
                name: _ctx.SETTING_PANE_NAMES.regularPhysicalExamination,
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_RegularPhysicalExamination, {
                    "active-name": _ctx.activeName,
                    name: _ctx.SETTING_PANE_NAMES.regularPhysicalExamination,
                    "policy-id": _ctx.policyId,
                    onCancel: _ctx.cancel,
                    onSave: _ctx.save,
                    "operate-type": _ctx.operateType
                  }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type"])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('groupPolicySettings.paneScheduledScan'),
                name: _ctx.SETTING_PANE_NAMES.timingAntivirus,
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TimingAntivirus, {
                    "active-name": _ctx.activeName,
                    name: _ctx.SETTING_PANE_NAMES.timingAntivirus,
                    "policy-id": _ctx.policyId,
                    onCancel: _ctx.cancel,
                    onSave: _ctx.save,
                    "operate-type": _ctx.operateType,
                    "system-tab": _ctx.systemTab
                  }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "system-tab"])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              (0)
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 0,
                    name: _ctx.SETTING_PANE_NAMES.flowControl,
                    lazy: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('groupPolicySettings.paneTrafficLimit')), 1),
                        _createVNode(_component_CmSvgIcon, {
                          class: "cm-icon-vip-badge",
                          name: "views/dashboard/_components/group-policy-settings/_images/vip_badge",
                          monochrome: "",
                          size: 18
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_FlowControl, {
                        "active-name": _ctx.activeName,
                        name: _ctx.SETTING_PANE_NAMES.flowControl,
                        "policy-id": _ctx.policyId,
                        onCancel: _ctx.cancel,
                        onSave: _ctx.save,
                        "operate-type": _ctx.operateType,
                        "has-permission": _ctx.flowHasPermission
                      }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "has-permission"])
                    ]),
                    _: 1
                  }, 8, ["name"]))
                : _createCommentVNode("", true),
              (!_ctx.IS_JP_ONLY_BUILD)
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 1,
                    name: _ctx.SETTING_PANE_NAMES.onlineBlackAndWhiteList,
                    lazy: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('groupPolicySettings.paneDomainLimit')), 1),
                        _createVNode(_component_CmSvgIcon, {
                          class: "cm-icon-vip-badge",
                          name: "views/dashboard/_components/group-policy-settings/_images/vip_badge",
                          monochrome: "",
                          size: 18
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_OnlineBlackAndWhiteList, {
                        "active-name": _ctx.activeName,
                        name: _ctx.SETTING_PANE_NAMES.onlineBlackAndWhiteList,
                        "policy-id": _ctx.policyId,
                        onCancel: _ctx.cancel,
                        onSave: _ctx.save,
                        "operate-type": _ctx.operateType,
                        "has-permission": _ctx.networkHasPermission,
                        "system-tab": _ctx.systemTab
                      }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "has-permission", "system-tab"])
                    ]),
                    _: 1
                  }, 8, ["name"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('groupPolicySettings.paneAlert'),
                name: _ctx.SETTING_PANE_NAMES.earlyWarningAndMonitoring,
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EarlyWarningAndMonitoring, {
                    "active-name": _ctx.activeName,
                    name: _ctx.SETTING_PANE_NAMES.earlyWarningAndMonitoring,
                    "policy-id": _ctx.policyId,
                    onCancel: _ctx.cancel,
                    onSave: _ctx.save,
                    "operate-type": _ctx.operateType
                  }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type"])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('groupPolicySettings.paneVulnFix'),
                name: _ctx.SETTING_PANE_NAMES.leakFix,
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LeakFix, {
                    "active-name": _ctx.activeName,
                    name: _ctx.SETTING_PANE_NAMES.leakFix,
                    "policy-id": _ctx.policyId,
                    onCancel: _ctx.cancel,
                    onSave: _ctx.save,
                    "operate-type": _ctx.operateType,
                    "system-tab": _ctx.systemTab
                  }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "system-tab"])
                ]),
                _: 1
              }, 8, ["label", "name"]),
              (!_ctx.IS_JP_ONLY_BUILD)
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 2,
                    name: _ctx.SETTING_PANE_NAMES.usbManage,
                    lazy: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('groupPolicySettings.paneUsb')), 1),
                        _createVNode(_component_CmSvgIcon, {
                          class: "cm-icon-vip-badge",
                          name: "views/dashboard/_components/group-policy-settings/_images/vip_badge",
                          monochrome: "",
                          size: 18
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_UsbManage, {
                        "active-name": _ctx.activeName,
                        name: _ctx.SETTING_PANE_NAMES.usbManage,
                        "policy-id": _ctx.policyId,
                        onCancel: _ctx.cancel,
                        onSave: _ctx.save,
                        "operate-type": _ctx.operateType,
                        "system-tab": _ctx.systemTab,
                        "has-permission": _ctx.usbManageHasPermission
                      }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "system-tab", "has-permission"])
                    ]),
                    _: 1
                  }, 8, ["name"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('groupPolicySettings.paneBaseline'),
                name: _ctx.SETTING_PANE_NAMES.baselineScan,
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaselineScan, {
                    "active-name": _ctx.activeName,
                    name: _ctx.SETTING_PANE_NAMES.baselineScan,
                    "policy-id": _ctx.policyId,
                    onCancel: _ctx.cancel,
                    onSave: _ctx.save,
                    "operate-type": _ctx.operateType,
                    "system-tab": _ctx.systemTab
                  }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "system-tab"])
                ]),
                _: 1
              }, 8, ["label", "name"])
            ]),
            _: 1
          }, 8, ["modelValue", "before-leave"])
        ]),
        _: 1
      }, 8, ["label"]),
      (!_ctx.IS_JP_ONLY_BUILD)
        ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 0,
            label: _ctx.$t('groupPolicySettings.tabLinux'),
            lazy: "",
            name: "2"
          }, {
            default: _withCtx(() => [
              (_ctx.systemTab === '2')
                ? (_openBlock(), _createBlock(_component_el_tabs, {
                    key: 0,
                    class: "content-adapt define-tabs",
                    modelValue: _ctx.linuxActiveName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.linuxActiveName) = $event)),
                    "before-leave": _ctx.switchTab
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tab_pane, {
                        name: _ctx.SETTING_PANE_NAMES.timingAntivirus,
                        lazy: ""
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('groupPolicySettings.paneScheduledScan')), 1),
                            _createVNode(_component_CmSvgIcon, {
                              class: "cm-icon-vip-badge",
                              name: "views/dashboard/_components/group-policy-settings/_images/vip_badge",
                              monochrome: "",
                              size: 18
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_TimingAntivirus, {
                            "active-name": _ctx.linuxActiveName,
                            name: _ctx.SETTING_PANE_NAMES.timingAntivirus,
                            "policy-id": _ctx.policyId,
                            onCancel: _ctx.cancel,
                            onSave: _ctx.save,
                            "operate-type": _ctx.operateType,
                            "system-tab": _ctx.systemTab
                          }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "system-tab"])
                        ]),
                        _: 1
                      }, 8, ["name"]),
                      (_ctx.LinuxDriverSwitch.network && !_ctx.IS_JP_ONLY_BUILD)
                        ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                            key: 0,
                            name: _ctx.SETTING_PANE_NAMES.onlineBlackAndWhiteList,
                            lazy: ""
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(_ctx.$t('groupPolicySettings.paneDomainLimit')), 1),
                                _createVNode(_component_CmSvgIcon, {
                                  class: "cm-icon-vip-badge",
                                  name: "views/dashboard/_components/group-policy-settings/_images/vip_badge",
                                  monochrome: "",
                                  size: 18
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_OnlineBlackAndWhiteList, {
                                "active-name": _ctx.linuxActiveName,
                                name: _ctx.SETTING_PANE_NAMES.onlineBlackAndWhiteList,
                                "policy-id": _ctx.policyId,
                                onCancel: _ctx.cancel,
                                onSave: _ctx.save,
                                "operate-type": _ctx.operateType,
                                "has-permission": _ctx.networkHasPermission,
                                "system-tab": _ctx.systemTab
                              }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "has-permission", "system-tab"])
                            ]),
                            _: 1
                          }, 8, ["name"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_tab_pane, {
                        name: _ctx.SETTING_PANE_NAMES.leakFix,
                        lazy: ""
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('groupPolicySettings.paneVulnScan')), 1),
                            _createVNode(_component_CmSvgIcon, {
                              class: "cm-icon-vip-badge",
                              name: "views/dashboard/_components/group-policy-settings/_images/vip_badge",
                              monochrome: "",
                              size: 18
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_LeakFix, {
                            "active-name": _ctx.linuxActiveName,
                            name: _ctx.SETTING_PANE_NAMES.leakFix,
                            "policy-id": _ctx.policyId,
                            onCancel: _ctx.cancel,
                            onSave: _ctx.save,
                            "operate-type": _ctx.operateType,
                            "system-tab": _ctx.systemTab
                          }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "system-tab"])
                        ]),
                        _: 1
                      }, 8, ["name"]),
                      (_ctx.LinuxDriverSwitch.usb && !_ctx.IS_JP_ONLY_BUILD)
                        ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                            key: 1,
                            name: _ctx.SETTING_PANE_NAMES.usbManage,
                            lazy: ""
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(_ctx.$t('groupPolicySettings.paneUsb')), 1),
                                _createVNode(_component_CmSvgIcon, {
                                  class: "cm-icon-vip-badge",
                                  name: "views/dashboard/_components/group-policy-settings/_images/vip_badge",
                                  monochrome: "",
                                  size: 18
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_UsbManage, {
                                "active-name": _ctx.linuxActiveName,
                                name: _ctx.SETTING_PANE_NAMES.usbManage,
                                "policy-id": _ctx.policyId,
                                onCancel: _ctx.cancel,
                                onSave: _ctx.save,
                                "operate-type": _ctx.operateType,
                                "has-permission": _ctx.usbManageHasPermission,
                                "system-tab": _ctx.systemTab
                              }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "has-permission", "system-tab"])
                            ]),
                            _: 1
                          }, 8, ["name"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_tab_pane, {
                        name: _ctx.SETTING_PANE_NAMES.baselineScan,
                        lazy: ""
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('groupPolicySettings.paneBaseline')), 1),
                            _createVNode(_component_CmSvgIcon, {
                              class: "cm-icon-vip-badge",
                              name: "views/dashboard/_components/group-policy-settings/_images/vip_badge",
                              monochrome: "",
                              size: 18
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_BaselineScan, {
                            "active-name": _ctx.linuxActiveName,
                            name: _ctx.SETTING_PANE_NAMES.baselineScan,
                            "policy-id": _ctx.policyId,
                            onCancel: _ctx.cancel,
                            onSave: _ctx.save,
                            "operate-type": _ctx.operateType,
                            "system-tab": _ctx.systemTab
                          }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "system-tab"])
                        ]),
                        _: 1
                      }, 8, ["name"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "before-leave"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      (!_ctx.HIDE_FUNC.macos && !_ctx.IS_JP_ONLY_BUILD)
        ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 1,
            label: _ctx.$t('groupPolicySettings.tabMacOS'),
            name: "4",
            lazy: ""
          }, {
            default: _withCtx(() => [
              (_ctx.systemTab === '4')
                ? (_openBlock(), _createBlock(_component_el_tabs, {
                    key: 0,
                    class: "content-adapt define-tabs",
                    modelValue: _ctx.macActiveName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.macActiveName) = $event)),
                    "before-leave": _ctx.switchTab
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tab_pane, {
                        label: _ctx.$t('groupPolicySettings.paneScheduledScan'),
                        name: _ctx.SETTING_PANE_NAMES.timingAntivirus,
                        lazy: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TimingAntivirus, {
                            "active-name": _ctx.macActiveName,
                            name: _ctx.SETTING_PANE_NAMES.timingAntivirus,
                            "policy-id": _ctx.policyId,
                            onCancel: _ctx.cancel,
                            onSave: _ctx.save,
                            "operate-type": _ctx.operateType,
                            "system-tab": _ctx.systemTab
                          }, null, 8, ["active-name", "name", "policy-id", "onCancel", "onSave", "operate-type", "system-tab"])
                        ]),
                        _: 1
                      }, 8, ["label", "name"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "before-leave"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "before-leave", "class"]))
}